// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('contacts.users.new', {
        url: '/new',
        views: {
            "contactView@contacts": {
                templateUrl: 'main/contacts/users/user/user.tpl.html',
                controller: 'ContactsUserController as vm'
            }
        },
        resolve: {
            user: function() { return { isActive: true};}
        }
    });
    $stateProvider.state('contacts.users.user', {
        url: '/{userId}',
        views: {
            "contactView@contacts": {
                templateUrl: 'main/contacts/users/user/user.tpl.html',
                controller: 'ContactsUserController as vm'
            }
        },
        resolve: {
            user: userResolver
        }
    });
}

// @ngInject
function userResolver($stateParams,UsersApiService) {
    return UsersApiService.getById($stateParams.userId);
}

// @ngInject
function ContactsUserController($q,$scope, $rootScope, $state,user,HelperService,UsersApiService,loadSpinnerService,AuthService,userPrintQRCodeDialogService) {
    var vm = this;
    var isNewUser = !user.id;

    //Properties
    vm.isEditing = false;
    vm.addressTypes = [];
    vm.contactInfoTypes = [];
    vm.availableAddressTypes = [];
    vm.availableContactInfoTypes = [];
    vm.selectedLocations = [];
    vm.selectedBrands = [];
    vm.locations = [];
    vm.brands = [];
    vm.newAddress = {};
    vm.newContactInfo = {};
    vm.selectedUser = user;
    vm.selectedUserCopy = angular.copy(vm.selectedUser);
    vm.validationErrors = [];
    vm.salaryTypes = ['T', 'M'];
    vm.canAccess = AuthService.canAccess;
    vm.isEmailValid = false;
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    //Methods
    vm.isNewUser = isNewUser;
    vm.save = save;
    vm.startEdit = startEdit;
    vm.cancelEdit = cancelEdit;
    vm.addNewAddress = addNewAddress;
    vm.removeAddress = removeAddress;
    vm.addNewContactInfo = addNewContactInfo;
    vm.removeContactInfo = removeContactInfo;
    vm.isAllInformationValid = isAllInformationValid;
    vm.hasEmail = hasEmail;
    vm.validateEmail = validateEmail;
    vm.hasFirstName = hasFirstName;
    vm.hasLastName = hasLastName;
    vm.hasUserName = hasUserName;
    vm.hasPassword = hasPassword;
    vm.hasRole = hasRole;
    vm.isEmailInfo = isEmailInfo;
    vm.openPrintQRCodeModal = openPrintQRCodeModal;

    validateEmail();
    activate();

    function activate() {
        UsersApiService.getAddressTypes().then(function(types) {
            vm.addressTypes = types;
            resetTypes();
        });
        UsersApiService.getContactInfoTypes().then(function(types) {
            vm.contactInfoTypes = types;
            if (isNewUser) {

                vm.isEditing = true;
                vm.selectedUserCopy.contactInfos = vm.selectedUserCopy.contactInfos || [];
                const contactInfoTypeEmail = vm.contactInfoTypes.find(x => x.systemTypeName === "Email") ;
                const emailContactInfo = 
                {
                    contactInfoType : contactInfoTypeEmail
                }
                vm.selectedUserCopy.contactInfos.push(emailContactInfo);
    
            }

            resetTypes();
        });
        UsersApiService.getLocations().then(function(locations) {
            vm.locations = locations;
        });
        UsersApiService.getValidRoles().then(function(roles) {
            vm.roles = roles;
        });
        UsersApiService.getBrands().then(function(brands) {
            vm.brands = brands;
        });

        var intervalId = window.setInterval(function(){
            if(vm.isEditing)
                validateEmail();
        }, 3000)
    }

    function openPrintQRCodeModal(){
        userPrintQRCodeDialogService.showDialog(vm.selectedUserCopy).then(function(response){
            if(response)
                console.log("OK!");
        });
    }

    function addNewAddress() {
        vm.selectedUserCopy.addresses = vm.selectedUserCopy.addresses || [];
        vm.selectedUserCopy.addresses.push(_.clone(vm.newAddress));
        resetTypes();
    }

    function addNewContactInfo() {
        vm.selectedUserCopy.contactInfos = vm.selectedUserCopy.contactInfos || [];
        vm.selectedUserCopy.contactInfos.push(_.clone(vm.newContactInfo));
        resetTypes();
    }

    function save() {
        if (isNewUser) {
            return saveNewUser();
        } else {
            return updateUser();
        }
    }

    function startEdit() {
        vm.selectedUserCopy = angular.copy(user);
        vm.selectedLocations = vm.selectedUserCopy.locations || [];
        vm.selectedBrands = vm.selectedUserCopy.brands || [];
        resetTypes();
        vm.isEditing = true;
    }

    function resetTypes() {
        vm.newAddress = {};
        vm.newContactInfo = {};
        vm.availableAddressTypes = getAvailableAddressTypes();
        vm.availableContactInfoTypes = getAvailableContactInfoTypes();
    }

    function cancelEdit() {
        vm.selectedUserCopy = angular.copy(user);
        vm.validationErrors = [];
        vm.isEditing = false;
    }

    function getAvailableAddressTypes() {
        return _.filter(vm.addressTypes, function(obj) {
            if (!vm.selectedUserCopy.addresses) {
                return true;
            } else {
                return !_.find(vm.selectedUserCopy.addresses, { addressType: { id: obj.id }});
            }
        });
    }

    function getAvailableContactInfoTypes() {
        return _.filter(vm.contactInfoTypes, function(obj) { return !_.find(vm.selectedUserCopy.contactInfos, {contactInfoType: { id: obj.id }}); });
    }

    function removeAddress(address) {
        vm.selectedUserCopy.addresses.splice(_.findIndex(vm.selectedUserCopy.addresses,{addressType:{typeName:address.addressType.typeName}}),1);
        resetTypes();
    }

    function removeContactInfo(contactInfo) {
        vm.selectedUserCopy.contactInfos.splice(_.findIndex(vm.selectedUserCopy.contactInfos,{contactInfoType:{typeName:contactInfo.contactInfoType.typeName}}),1);
        resetTypes();
    }

    function updateUser() {
        vm.validationErrors = [];

        vm.selectedUserCopy.brands = vm.selectedBrands;
        vm.selectedUserCopy.locations = vm.selectedLocations;

        var propertiesToInspect = ['firstName','lastName','username', 'usernamePos', 'password','addresses','contactInfos','locations','role','isActive','startDate','employeeNumber', 'usesTimeStamping', 'salaryType', 'socialSecurityNumber', 'brands', 'isAllowedToViewCommonReports'];

        HelperService.setUndefinedToNull(user, propertiesToInspect);
        var changedData = HelperService.getChangedData(user, vm.selectedUserCopy, propertiesToInspect);
        changedData.role = vm.selectedUserCopy.role

        if (!_.isEmpty(changedData)) {
            loadSpinnerService.start('mainSpinner');
            UsersApiService.updateUserInfo(changedData,user.id).then(function(response) {
                user = angular.copy(response);
                vm.selectedUserCopy = angular.copy(response);
                vm.cancelEdit();
                $rootScope.$emit('User.Changed', response);
            }, function(error) {
                if (error.errors) {
                    error.errors.forEach(function (error) {
                        vm.validationErrors.push(error);
                    }, this);
                }
                if (error.message.length > 0) {
                    vm.validationErrors.push({ message: error.message});
                }
            }).finally(function() {
                loadSpinnerService.stop('mainSpinner');
            });
        }
    }

    function saveNewUser() {
        vm.validationErrors = [];

        vm.selectedUserCopy.brands = vm.selectedBrands;
        vm.selectedUserCopy.locations = vm.selectedLocations;

        if (!vm.selectedUserCopy.startDate) {
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1; //January is 0!
            var yyyy = today.getFullYear();

            if (dd < 10) {
                dd = '0' + dd;
            }

            if (mm < 10) {
                mm = '0' + mm;
            }

            today = yyyy + '-' + mm + '-' + dd; //2015-05-13T22:00:00.000Z
            vm.selectedUserCopy.startDate = today;
        }

        loadSpinnerService.start('mainSpinner');
        UsersApiService.newUser(vm.selectedUserCopy).then(function(response) {
            $state.go('contacts.users.user', {userId: response.id});
            $rootScope.$emit('User.Inserted', response);
            vm.cancelEdit();
        }, function(error) {
            if (error.errors) {
                error.errors.forEach(function(error) {
                    vm.validationErrors.push(error);
                }, this);
            }
            if (error.message.length > 0) {
                vm.validationErrors.push({ message: error.message});
            }
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function isAllInformationValid() {
        return hasFirstName() &&
                hasLastName() &&
                hasUserName() &&
                hasPassword() &&
                hasEmail() &&
                hasRole() &&
                vm.isEmailValid;
    }
    function hasFirstName() {
        return vm.selectedUserCopy && vm.selectedUserCopy.firstName && vm.selectedUserCopy.firstName.length > 0;
    }
    function hasLastName() {
        return vm.selectedUserCopy && vm.selectedUserCopy.lastName && vm.selectedUserCopy.lastName.length > 0;
    }
    function hasUserName() {
        return vm.selectedUserCopy && vm.selectedUserCopy.username && vm.selectedUserCopy.username.length > 0;
    }
    function hasPassword() {
        return vm.selectedUserCopy && vm.selectedUserCopy.password && vm.selectedUserCopy.password.length > 0;
    }
    function hasRole() {
        return vm.selectedUserCopy && vm.selectedUserCopy.role && vm.selectedUserCopy.role.id != -1;
    }
    function hasEmail() {
        return vm.selectedUserCopy && vm.selectedUserCopy.contactInfos && vm.selectedUserCopy.contactInfos.find(info => info.contactInfoType.systemTypeName === "Email");
    }
    function isEmailInfo(contactInfo) {
        console.log(contactInfo);
    }


    function validateEmail()
    {
        if(vm.selectedUserCopy.contactInfos !== undefined) {
            var length = vm.selectedUserCopy.contactInfos.length;
            try{
                for (let i = 0; i < length; i++){
                    if(vm.selectedUserCopy.contactInfos[i].contactInfoType.systemTypeName === "Email"){
                        var email = vm.selectedUserCopy.contactInfos[i];
                        vm.isEmailValid = email.value.match(mailformat);
                        break;
                    }
                    vm.isEmailValid = false;
                }
            }catch(err){
                vm.isEmailValid = false;
            }
        }
        else{
            vm.isEmailValid = false;
        }
    }
}

angular.module('contacts.users.user', [])
    .config(stateConfig)
    .controller('ContactsUserController', ContactsUserController);
